import React, { useState, useEffect } from 'react'
import fire from './Firebase'
import OptionsModal from './OptionsModal'
import Slide from 'react-reveal/Slide';

function Skills(props) {

    const themeColors = props.themeColors
    const darkMode = props.darkMode
    const [icoReact, setReact] = useState('')
    const [icoHtml, setHtml] = useState('')
    const [icoJS, setJS] = useState('')
    const [icoCss, setCss] = useState('')
    const [icoPy, setPy] = useState('')
    const [icoAngular, setAngular] = useState('')
    const [icoNodejs, setNodejs] = useState('')
    const [icoDjango, setDjango] = useState('')
    const [icoFlutter, setFlutter] = useState('')
    const [icoGatsby, setGatsby] = useState('')
    const [icoNextjs, setNextjs] = useState('')
    const [icoMongodb, setMongodb] = useState('')
    const [icoFirebase, setFirebase] = useState('')
    const [icoVscode, setVscode] = useState('')
    const [icoLinux, setLinux] = useState('')
    const [icoGithub, setGithub] = useState('')
    const [icoAws, setAws] = useState('')
    const [icoShopify, setShopify] = useState('')
    const [icoNetlify, setNetlify] = useState('')
    const [icoMetasploit, setMetasploit] = useState('')
    const [icoSelenium, setSelenium] = useState('')
    const [icoAppium, setAppium] = useState('')
    const [icoNpm, setNpm] = useState('')
    const [icoStrapi, setStrapi] = useState('')
    const [icoYarn, setYarn] = useState('')
    const [icoPutty, setPutty] = useState('')
    const [icoFilezilla, setFilezilla] = useState('')
    const [icoCapacitor, setCapacitor] = useState('')
    const [showOptModal, setShowOptModal] = useState(false)
    const [link, setLink] = useState(null)


    const skillsLangList = [{ name: 'HTML', ico: icoHtml, link: 'https://html.spec.whatwg.org/' }, { name: 'JavaScript', ico: icoJS, link: 'https://en.wikipedia.org/wiki/JavaScript' }, { name: 'CSS', ico: icoCss, link: 'https://www.w3.org/Style/CSS/Overview.en.html' }, { name: 'Python', ico: icoPy, link: 'https://www.python.org/' }, {name: "Rust (Learning)", ico:"https://www.rust-lang.org/logos/rust-logo-512x512.png", link: "https://www.rust-lang.org/" }]
    const skillsFrameworkList = [{ name: 'React JS', ico: icoReact, link: 'https://reactjs.org' }, { name: 'Node JS', ico: icoNodejs, link: 'https://nodejs.org/' }, { name: 'Next JS', ico: icoNextjs, link: 'https://nextjs.org/' }, { name: 'React Native', ico: icoReact, link: 'https://reactnative.dev/' }, { name: "Capacitor JS", link: "https://capacitorjs.com/", ico: icoCapacitor }]
    const skillsDbList = [{ name: 'MongoDB', ico: icoMongodb, link: 'https://www.mongodb.com/' }, { name: 'Firestore', ico: icoFirebase, link: 'https://firebase.google.com/products/firestore' }]
    const skillsOthersList = [{ name: 'Linux', ico: icoLinux, link: 'https://www.linuxfoundation.org/' }, { name: 'GitHub', ico: icoGithub, link: 'https://github.com/' }, { name: 'VSCode', ico: icoVscode, link: 'https://code.visualstudio.com/' }, { name: 'Firebase', ico: icoFirebase, link: 'https://firebase.google.com/' }, { name: 'Shopify', ico: icoShopify, link: 'https://www.shopify.in' }, { name: 'AWS', ico: icoAws, link: 'https://aws.amazon.com/' }, { name: 'Netlify', ico: icoNetlify, link: 'https://www.netlify.com/' }, { name: 'Metasploit', ico: icoMetasploit, link: 'https://www.metasploit.com/' }, { name: 'Selenium', ico: icoSelenium, link: 'https://www.selenium.dev/' }, { name: 'Appium', ico: icoAppium, link: 'http://appium.io/' }, { name: 'NPM', ico: icoNpm, link: 'https://www.npmjs.com/' }, { name: 'Yarn', ico: icoYarn, link: 'https://yarnpkg.com/' }, { name: 'Putty', ico: icoPutty, link: 'https://www.putty.org/' }, { name: 'FileZilla', ico: icoFilezilla, link: 'https://filezilla-project.org/' }]

    // { name: 'Angular', ico: icoAngular, link: 'https://angular.io/' },
    // { name: 'Strapi', ico: icoStrapi, link: 'https://strapi.io/' }
    // ,  { name: 'Flutter', ico: icoFlutter, link: 'https://flutter.dev/' },
    // { name: 'Gatsby', ico: icoGatsby, link: 'https://www.gatsbyjs.com/' }
    // { name: 'Django', ico: icoDjango, link: 'https://www.djangoproject.com/' },

    useEffect(() => {
        fire.storage().ref('assets/react.png').getDownloadURL().then((url) => {
            setReact(url)
        })
        fire.storage().ref('assets/html-5.png').getDownloadURL().then((url) => {
            setHtml(url)
        })
        fire.storage().ref('assets/javascript.png').getDownloadURL().then((url) => {
            setJS(url)
        })
        fire.storage().ref('assets/css3.png').getDownloadURL().then((url) => {
            setCss(url)
        })
        fire.storage().ref('assets/python.png').getDownloadURL().then((url) => {
            setPy(url)
        })
        fire.storage().ref('assets/angular.png').getDownloadURL().then((url) => {
            setAngular(url)
        })
        fire.storage().ref('assets/nodejs.png').getDownloadURL().then((url) => {
            setNodejs(url)
        })
        fire.storage().ref('assets/django.png').getDownloadURL().then((url) => {
            setDjango(url)
        })
        fire.storage().ref('assets/flutter.png').getDownloadURL().then((url) => {
            setFlutter(url)
        })
        fire.storage().ref('assets/shopify.png').getDownloadURL().then((url) => {
            setShopify(url)
        })
        fire.storage().ref('assets/gatsby.png').getDownloadURL().then((url) => {
            setGatsby(url)
        })
        fire.storage().ref('assets/next.png').getDownloadURL().then((url) => {
            setNextjs(url)
        })
        fire.storage().ref('assets/strapi.png').getDownloadURL().then((url) => {
            setStrapi(url)
        })
        fire.storage().ref('assets/mongodb.png').getDownloadURL().then((url) => {
            setMongodb(url)
        })
        fire.storage().ref('assets/firebase.png').getDownloadURL().then((url) => {
            setFirebase(url)
        })
        fire.storage().ref('assets/vscode.png').getDownloadURL().then((url) => {
            setVscode(url)
        })
        fire.storage().ref('assets/linux.png').getDownloadURL().then((url) => {
            setLinux(url)
        })
        fire.storage().ref('assets/github.png').getDownloadURL().then((url) => {
            setGithub(url)
        })
        fire.storage().ref('assets/aws.png').getDownloadURL().then((url) => {
            setAws(url)
        })
        fire.storage().ref('assets/netlify.png').getDownloadURL().then((url) => {
            setNetlify(url)
        })
        fire.storage().ref('assets/metasploit.png').getDownloadURL().then((url) => {
            setMetasploit(url)
        })
        fire.storage().ref('assets/selenium.png').getDownloadURL().then((url) => {
            setSelenium(url)
        })
        fire.storage().ref('assets/appium.png').getDownloadURL().then((url) => {
            setAppium(url)
        })
        fire.storage().ref('assets/npm.png').getDownloadURL().then((url) => {
            setNpm(url)
        })
        fire.storage().ref('assets/yarn.png').getDownloadURL().then((url) => {
            setYarn(url)
        })
        fire.storage().ref('assets/putty.png').getDownloadURL().then((url) => {
            setPutty(url)
        })
        fire.storage().ref('assets/filezilla.png').getDownloadURL().then((url) => {
            setFilezilla(url)
        })
        fire.storage().ref('assets/Capacitorjs.png').getDownloadURL().then((url) => {
            setCapacitor(url)
        })

    }, [])

    const clickOpt = (link) => {
        setLink(link)
        setShowOptModal(true)
    }

    return (
        <div style={{ flex: 1, overflow: 'auto', height: 'auto', overflowX: 'hidden' }}>
            <div>
                <p><span style={{ marginRight: 5 }}>&#9679;</span>Programming/Markup Languages</p>
                {skillsLangList.map((items) =>
                    <div key={items.name} onClick={() => clickOpt(items.link)} style={{ display: 'flex', backgroundColor: darkMode ? themeColors.darkOn.container.secondary : themeColors.darkOff.container.secondary, height: 70, marginBottom: 5, marginTop: 5, cursor: 'pointer' }}>
                        <Slide right>
                            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', paddingRight: 3 }}>
                                <img alt="" style={{ height: 30, width: 30, background: items.name.startsWith("Rust") && '#EFF2F5', borderRadius: items.name.startsWith("Rust") && 999 }} src={items.ico} />
                            </div>
                            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'flex-start', paddingLeft: 3 }}>
                                <p>{items.name}</p>
                            </div>
                        </Slide>
                    </div>)}
            </div>
            <div>
                <p><span style={{ marginRight: 5 }}>&#9679;</span>Libraries/Frameworks</p>
                {skillsFrameworkList.map((items) =>
                    <div key={items.name} onClick={() => clickOpt(items.link)} style={{ display: 'flex', backgroundColor: darkMode ? themeColors.darkOn.container.secondary : themeColors.darkOff.container.secondary, height: 70, marginBottom: 5, marginTop: 5, cursor: 'pointer' }}>
                        <Slide right>
                            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', paddingRight: 3 }}>
                                <img alt="" style={{ height: 30, width: 30 }} src={items.ico} />
                            </div>
                            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'flex-start', paddingLeft: 3 }}>
                                <p>{items.name}</p>
                            </div>
                        </Slide>
                    </div>)}
            </div>
            <div>
                <p><span style={{ marginRight: 5 }}>&#9679;</span>Database</p>
                {skillsDbList.map((items) =>
                    <div key={items.name} onClick={() => clickOpt(items.link)} style={{ display: 'flex', backgroundColor: darkMode ? themeColors.darkOn.container.secondary : themeColors.darkOff.container.secondary, height: 70, marginBottom: 5, marginTop: 5, cursor: 'pointer' }}>
                        <Slide right>
                            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', paddingRight: 3 }}>
                                <img alt="" style={{ height: 30, width: 30 }} src={items.ico} />
                            </div>
                            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'flex-start', paddingLeft: 3 }}>
                                <p>{items.name}</p>
                            </div>
                        </Slide>
                    </div>)}
            </div>
            <div>
                <p><span style={{ marginRight: 5 }}>&#9679;</span>Others</p>
                {skillsOthersList.map((items) =>
                    <div key={items.name} onClick={() => clickOpt(items.link)} style={{ display: 'flex', backgroundColor: darkMode ? themeColors.darkOn.container.secondary : themeColors.darkOff.container.secondary, height: 70, marginBottom: 5, marginTop: 5, cursor: 'pointer' }}>
                        <Slide right>
                            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', paddingRight: 3 }}>
                                <img alt="" style={{ height: 30, width: 30 }} src={items.ico} />
                            </div>
                            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'flex-start', paddingLeft: 3 }}>
                                <p>{items.name}</p>
                            </div>
                        </Slide>
                    </div>)}
            </div>
            <div style={{ display: showOptModal ? 'flex' : 'none', zIndex:10 }}>
                <OptionsModal themeColors={themeColors} darkMode={darkMode} link={link} optCancel={() => setShowOptModal(false)} />
            </div>
            <div onClick={() => setShowOptModal(false)} style={{display: showOptModal ? 'flex' : 'none', position:'fixed', top:0, bottom:0, left:0, right:0, backdropFilter:'blur(5px)'}}></div>
        </div>

    )
}

export default Skills